.root {
  bottom: 24px;
  display: flex;
  justify-content: center;
  left: 0;
  pointer-events: none;
  position: fixed;
  right: 0;
  z-index: 9999;
}

.root-top-right {
  bottom: auto;
  justify-content: flex-end;
  padding-right: 24px;
  top: 24px;

  // Slide + fade in. Scoped to this placement so the long-standing
  // bottom-centre toasts keep their existing (motionless) behaviour.
  .toast {
    animation: toast-enter 200ms cubic-bezier(0.16, 1, 0.3, 1);
  }
}

@keyframes toast-enter {
  from {
    opacity: 0;
    transform: translate3d(0, -8px, 0) scale(0.98);
  }

  to {
    opacity: 1;
    transform: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .root-top-right .toast {
    animation: none;
  }
}

.toast {
  align-items: center;
  background: var(--color-foreground);
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
  color: var(--color-background);
  display: flex;
  gap: 12px;
  max-width: min(560px, 90vw);
  padding: 12px 16px;
  pointer-events: auto;
}

.toast-tone-error {
  background: var(--color-error);
  color: var(--color-background);
}

.toast-tone-success {
  background: var(--color-success-foreground);
  color: var(--color-background);
}

.body {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.title {
  font-size: 14px;
  font-weight: 600;
  line-height: 1.35;
}

.message {
  font-size: 14px;
  line-height: 1.4;
  min-width: 0;

  // Slightly recessive when it sits under a title.
  .title + & {
    font-size: 13px;
    opacity: 0.85;
  }
}

.action {
  background: transparent;
  // A hairline at 45% rather than a full-strength box: the action should read
  // as secondary to the message, not compete with it.
  border: 1px solid rgb(255 255 255 / 45%);
  border-radius: 6px;
  color: inherit;
  cursor: pointer;
  flex-shrink: 0;
  font: inherit;
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
  padding: 6px 10px;
  white-space: nowrap;

  &:hover {
    background: rgb(255 255 255 / 10%);
    border-color: rgb(255 255 255 / 70%);
  }

  // Lighter does not mean harder to reach: the focus ring stays full strength.
  &:focus-visible {
    outline: 2px solid var(--color-tooltip-fg, #fafafa);
    outline-offset: 2px;
  }
}
